import { CarregandoBloco, CarregandoFormulario, CarregandoLista } from "../../../components/carregando";
import { Skeleton } from "../../../components/ui/skeleton";

// Carregamento com cards (dono, 25/10/2026): enquanto chegam compras e
// ingredientes, a tela já mostra o formato dela — cabeçalho (fornecedor, data,
// pagamento) e as três colunas (histórico, adicionar item, itens) piscando —
// no lugar da bolinha girando sozinha.
export default function NovaCompraCarregando() {
  return (
    <div className="space-y-4" data-e2e="nova-compra-carregando" aria-busy="true" aria-label="Carregando">
      <div className="rounded-2xl border bg-card p-4 grid gap-3 sm:grid-cols-[minmax(0,2fr)_minmax(0,1fr)_minmax(0,1fr)]">
        {[0, 1, 2].map((i) => (
          <div key={i} className="space-y-2">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-11 w-full rounded-lg" />
          </div>
        ))}
      </div>
      <div className="grid gap-4 md:grid-cols-[minmax(0,2fr)_minmax(0,1fr)] xl:grid-cols-[minmax(0,1fr)_minmax(0,3fr)_minmax(0,1fr)]">
        <CarregandoBloco altura="h-[420px]" className="hidden xl:flex" />
        <CarregandoFormulario campos={3} />
        <CarregandoLista linhas={4} avatar={false} colunas={1} className="rounded-2xl border bg-card overflow-hidden hidden md:block" />
      </div>
    </div>
  );
}
